import script from "./ViewUsersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewUsersPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewUsersPage.vue?vue&type=style&index=0&id=295684fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295684fd"]])

export default __exports__